"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterBody = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var ListItem_1 = require("../ListItem/ListItem");
var ExcludeCurrentPeriodToggle_1 = require("../ExcludeCurrentPeriodToggle/ExcludeCurrentPeriodToggle");
var VisibleScrollbar_1 = require("../VisibleScrollbar/VisibleScrollbar");
var OptionUtils_1 = require("../utils/OptionUtils");
var AllTimeFilterItem_1 = require("./AllTimeFilterItem");
var DateFilterFormWrapper_1 = require("../DateFilterFormWrapper/DateFilterFormWrapper");
var AbsoluteDateFilterForm_1 = require("../AbsoluteDateFilterForm/AbsoluteDateFilterForm");
var ListItemTooltip_1 = require("../ListItemTooltip/ListItemTooltip");
var RelativeDateFilterForm_1 = require("../RelativeDateFilterForm/RelativeDateFilterForm");
var RelativePresetFilterItems_1 = require("./RelativePresetFilterItems");
var EditModeMessage_1 = require("./EditModeMessage");
var DateFilterHeader_1 = require("./DateFilterHeader");
var DateFilterBodyButton_1 = require("./DateFilterBodyButton");
var AbsolutePresetFilterItems_1 = require("./AbsolutePresetFilterItems");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ACTIONS_BUTTONS_HEIGHT = 53;
var EXCLUDE_OPEN_PERIOD_HEIGHT = 30; // height of 'Exclude open period' checkbox component
var MARGIN_BOTTOM = 8;
var MOBILE_WIDTH = 414; // iPhone 11 Pro Max
var ITEM_CLASS_MOBILE = "gd-date-filter-item-mobile";
var DateFilterBody = /** @class */ (function (_super) {
    tslib_1.__extends(DateFilterBody, _super);
    function DateFilterBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            route: null,
        };
        _this.changeRoute = function (route) {
            if (route === void 0) { route = null; }
            _this.setState({ route: route });
        };
        _this.renderAllTime = function () {
            var _a = _this.props, filterOptions = _a.filterOptions, isMobile = _a.isMobile, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange;
            return filterOptions.allTime ? (react_1.default.createElement(AllTimeFilterItem_1.AllTimeFilterItem, { filterOption: filterOptions.allTime, selectedFilterOption: selectedFilterOption, onSelectedFilterOptionChange: onSelectedFilterOptionChange, className: isMobile && ITEM_CLASS_MOBILE })) : null;
        };
        _this.renderAbsoluteForm = function () {
            var _a = _this.props, dateFormat = _a.dateFormat, filterOptions = _a.filterOptions, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, isMobile = _a.isMobile, errors = _a.errors;
            if (!filterOptions.absoluteForm) {
                return null;
            }
            var route = _this.state.route;
            var isSelected = filterOptions.absoluteForm.localIdentifier === selectedFilterOption.localIdentifier;
            var isOnRoute = route === "absoluteForm";
            return (react_1.default.createElement(react_1.default.Fragment, null,
                (!isMobile || !isOnRoute) && (react_1.default.createElement(ListItem_1.ListItem, { isSelected: isSelected, onClick: function () {
                        _this.changeRoute("absoluteForm");
                        if (!sdk_backend_spi_1.isAbsoluteDateFilterForm(selectedFilterOption)) {
                            onSelectedFilterOptionChange(filterOptions.absoluteForm);
                        }
                    }, className: classnames_1.default("s-absolute-form", "s-do-not-close-dropdown-on-click", isMobile && ITEM_CLASS_MOBILE) }, filterOptions.absoluteForm.name ? (filterOptions.absoluteForm.name) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.staticPeriod" })))),
                isSelected && (!isMobile || isOnRoute) && (react_1.default.createElement(DateFilterFormWrapper_1.DateFilterFormWrapper, { isMobile: isMobile },
                    react_1.default.createElement(AbsoluteDateFilterForm_1.AbsoluteDateFilterForm, { dateFormat: dateFormat, errors: (errors && errors.absoluteForm) || undefined, onSelectedFilterOptionChange: onSelectedFilterOptionChange, selectedFilterOption: selectedFilterOption, isMobile: isMobile })))));
        };
        _this.renderRelativeForm = function () {
            var _a = _this.props, filterOptions = _a.filterOptions, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, availableGranularities = _a.availableGranularities, isMobile = _a.isMobile;
            if (!filterOptions.relativeForm) {
                return null;
            }
            var route = _this.state.route;
            var isSelected = filterOptions.relativeForm.localIdentifier === selectedFilterOption.localIdentifier;
            var isOnRoute = route === "relativeForm";
            return (react_1.default.createElement(react_1.default.Fragment, null,
                (!isMobile || !isOnRoute) && (react_1.default.createElement(ListItem_1.ListItem, { isSelected: isSelected, onClick: function () {
                        _this.changeRoute("relativeForm");
                        if (!sdk_backend_spi_1.isRelativeDateFilterForm(selectedFilterOption)) {
                            onSelectedFilterOptionChange(filterOptions.relativeForm);
                        }
                    }, className: classnames_1.default("s-relative-form", "s-do-not-close-dropdown-on-click", isMobile && ITEM_CLASS_MOBILE) },
                    filterOptions.relativeForm.name ? (filterOptions.relativeForm.name) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.floatingRange" })),
                    !isMobile && (react_1.default.createElement(ListItemTooltip_1.ListItemTooltip, { bubbleAlignPoints: [{ align: "cr cl" }] },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.floatingRange.tooltip" }))))),
                isSelected && (!isMobile || isOnRoute) && (react_1.default.createElement(DateFilterFormWrapper_1.DateFilterFormWrapper, { isMobile: isMobile },
                    react_1.default.createElement(RelativeDateFilterForm_1.RelativeDateFilterForm, { onSelectedFilterOptionChange: function (option) {
                            onSelectedFilterOptionChange(option);
                        }, selectedFilterOption: selectedFilterOption, availableGranularities: availableGranularities, isMobile: isMobile })))));
        };
        _this.renderAbsolutePreset = function () {
            var _a = _this.props, dateFormat = _a.dateFormat, filterOptions = _a.filterOptions, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, isMobile = _a.isMobile;
            return filterOptions.absolutePreset && filterOptions.absolutePreset.length > 0 ? (react_1.default.createElement(AbsolutePresetFilterItems_1.AbsolutePresetFilterItems, { dateFormat: dateFormat, filterOptions: filterOptions.absolutePreset, selectedFilterOption: selectedFilterOption, onSelectedFilterOptionChange: onSelectedFilterOptionChange, className: isMobile && ITEM_CLASS_MOBILE })) : null;
        };
        _this.renderRelativePreset = function () {
            var _a = _this.props, dateFormat = _a.dateFormat, filterOptions = _a.filterOptions, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, isMobile = _a.isMobile;
            return filterOptions.relativePreset ? (react_1.default.createElement(RelativePresetFilterItems_1.RelativePresetFilterItems, { dateFormat: dateFormat, filterOption: filterOptions.relativePreset, selectedFilterOption: selectedFilterOption, onSelectedFilterOptionChange: onSelectedFilterOptionChange, className: isMobile && ITEM_CLASS_MOBILE })) : null;
        };
        _this.renderExcludeCurrent = function () {
            var _a = _this.props, selectedFilterOption = _a.selectedFilterOption, onExcludeCurrentPeriodChange = _a.onExcludeCurrentPeriodChange, excludeCurrentPeriod = _a.excludeCurrentPeriod, isExcludeCurrentPeriodEnabled = _a.isExcludeCurrentPeriodEnabled;
            return (react_1.default.createElement(ExcludeCurrentPeriodToggle_1.ExcludeCurrentPeriodToggle, { value: excludeCurrentPeriod, onChange: onExcludeCurrentPeriodChange, disabled: !isExcludeCurrentPeriodEnabled, granularity: OptionUtils_1.getDateFilterOptionGranularity(selectedFilterOption) }));
        };
        _this.calculateHeight = function (showExcludeCurrent) {
            // Mobile in Horizontal Layout
            if (window.innerHeight <= MOBILE_WIDTH) {
                var excludeOpenPeriodHeight = showExcludeCurrent ? EXCLUDE_OPEN_PERIOD_HEIGHT : 0;
                return window.innerHeight - excludeOpenPeriodHeight - ACTIONS_BUTTONS_HEIGHT - MARGIN_BOTTOM;
            }
            return undefined;
        };
        return _this;
    }
    DateFilterBody.prototype.componentDidMount = function () {
        // Dropdown component does not expose isOpened prop but it mounts
        // this component every time it is opened and un-mounts when closed
        if (this.props.isMobile) {
            if (sdk_backend_spi_1.isAbsoluteDateFilterForm(this.props.selectedFilterOption)) {
                this.changeRoute("absoluteForm");
            }
            else if (sdk_backend_spi_1.isRelativeDateFilterForm(this.props.selectedFilterOption)) {
                this.changeRoute("relativeForm");
            }
        }
    };
    DateFilterBody.prototype.render = function () {
        var _a = this.props, isExcludeCurrentPeriodEnabled = _a.isExcludeCurrentPeriodEnabled, isMobile = _a.isMobile, isEditMode = _a.isEditMode, onApplyClick = _a.onApplyClick, onCancelClick = _a.onCancelClick, closeDropdown = _a.closeDropdown, selectedFilterOption = _a.selectedFilterOption, dateFilterButton = _a.dateFilterButton, errors = _a.errors;
        var route = this.state.route;
        var showExcludeCurrent = !isMobile || isExcludeCurrentPeriodEnabled;
        var bodyHeight = this.calculateHeight(showExcludeCurrent);
        var wrapperStyle = {};
        var scrollerStyle = {};
        if (bodyHeight) {
            // display: flex causes the scroller is cut off when scrolling
            wrapperStyle = { display: "block", height: bodyHeight + "px" };
            scrollerStyle = { minHeight: bodyHeight + "px" };
        }
        return (react_1.default.createElement("div", { className: "gd-extended-date-filter-container" },
            react_1.default.createElement("div", { className: classnames_1.default("gd-extended-date-filter-body", "s-extended-date-filters-body", isMobile && "gd-extended-date-filter-body-mobile") },
                route === null && isMobile && (react_1.default.createElement("div", { onClick: function () {
                        onCancelClick();
                        closeDropdown();
                    } }, dateFilterButton)),
                react_1.default.createElement("div", { className: classnames_1.default("gd-extended-date-filter-body-wrapper", {
                        "gd-extended-date-filter-body-wrapper-wide": sdk_backend_spi_1.isRelativeDateFilterForm(selectedFilterOption),
                    }), style: wrapperStyle },
                    isEditMode && !isMobile && react_1.default.createElement(EditModeMessage_1.EditModeMessage, null),
                    isMobile ? (this.renderMobileContent()) : (react_1.default.createElement(VisibleScrollbar_1.VisibleScrollbar, { className: "gd-extended-date-filter-body-scrollable", style: scrollerStyle }, this.renderDefaultContent()))),
                showExcludeCurrent ? this.renderExcludeCurrent() : null,
                react_1.default.createElement("div", { className: classnames_1.default("gd-extended-date-filter-actions") },
                    react_1.default.createElement("div", { className: "gd-extended-date-filter-actions-buttons" },
                        react_1.default.createElement(DateFilterBodyButton_1.DateFilterBodyButton, { messageId: "cancel", className: "gd-button-secondary s-date-filter-cancel", onClick: function () {
                                onCancelClick();
                                closeDropdown();
                            } }),
                        react_1.default.createElement(DateFilterBodyButton_1.DateFilterBodyButton, { messageId: "apply", className: "gd-button-action s-date-filter-apply", disabled: !isEmpty_1.default(errors), onClick: function () {
                                onApplyClick();
                                closeDropdown();
                            } }))))));
    };
    DateFilterBody.prototype.renderMobileContent = function () {
        var route = this.state.route;
        if (route === "absoluteForm") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DateFilterHeader_1.DateFilterHeader, { changeRoute: this.changeRoute },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.staticPeriod" })),
                this.renderAbsoluteForm()));
        }
        if (route === "relativeForm") {
            return isEmpty_1.default(this.props.availableGranularities) ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DateFilterHeader_1.DateFilterHeader, { changeRoute: this.changeRoute },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.floatingRange" })),
                this.renderRelativeForm()));
        }
        return this.renderDefaultContent();
    };
    DateFilterBody.prototype.renderDefaultContent = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderAllTime(),
            this.renderAbsoluteForm(),
            !isEmpty_1.default(this.props.availableGranularities) && this.renderRelativeForm(),
            this.renderAbsolutePreset(),
            this.renderRelativePreset()));
    };
    return DateFilterBody;
}(react_1.default.Component));
exports.DateFilterBody = DateFilterBody;
//# sourceMappingURL=DateFilterBody.js.map